function ww_hexToRgb(hex) {
  var h = hex.replace('#', '');
  if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
  var num = parseInt(h, 16);
  return [(num >> 16) & 255, (num >> 8) & 255, num & 255].join(', ');
}

var WW_VARIANT_COLOR_MAP = {
  'midnight black': { accent: '#FF5A33', name: 'Schwarz' },
  'cloudy white': { accent: '#EDEAE2', name: 'Wei\u00DF' },
  'haze blue': { accent: '#7FC7E8', name: 'Blau' },
  'morning light powder': { accent: '#F09BC0', name: 'Pink' },
  'mint green': { accent: '#5FC98A', name: 'Gr\u00FCn' }
};

/**
 * Sets --ww-accent on the root element synchronously, before <body> is
 * parsed or the page paints. This script tag is a plain, blocking <script>
 * placed in <head> (not deferred, not a module), so this runs immediately.
 *
 * This matters specifically for iOS/Safari 26+ ("Liquid Glass"): it no
 * longer reads <meta name="theme-color"> at all, and instead samples the
 * background-color of position:fixed/sticky elements (here: .header-section,
 * see sections/header.liquid) once, at render time - changes made via JS
 * after the page has painted are not picked up. Restoring the saved accent
 * this early, before first paint, is what lets the correct color show up
 * on iOS 26 from the very first frame of every page load/navigation.
 * (Older Safari/desktop/Android still additionally get the theme-color meta
 * tag update below, which they do react to dynamically.)
 */
(function ww_restoreAccentBeforePaint() {
  try {
    var savedAccent = localStorage.getItem('ww_accent');
    if (savedAccent) {
      document.documentElement.style.setProperty('--ww-accent', savedAccent);
    }
  } catch (e) {}
})();

/**
 * Updates the iOS/Safari address-bar (theme-color) meta tag to match the
 * currently selected accent color.
 *
 * Reuses the theme's own `changeMetaThemeColor()` (assets/utilities.js),
 * exposed on `Theme.utilities` for non-module scripts, so this stays the
 * single place in the theme that writes to <meta name="theme-color">. The
 * inline fallback only covers the (rare) case where utilities.js hasn't
 * executed yet and mirrors that function exactly - it is not a second,
 * independent implementation.
 */
function ww_setMetaThemeColor(color) {
  if (!color) return;
  if (window.Theme && window.Theme.utilities && typeof window.Theme.utilities.changeMetaThemeColor === 'function') {
    window.Theme.utilities.changeMetaThemeColor(color);
    return;
  }
  var meta = document.head.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', color);
}

function ww_applyGallery(name) {
  if (!name) return;
  var dataEls = document.querySelectorAll('[data-ww-gallery-data] > [data-color]');
  var match = null;
  dataEls.forEach(function (el) {
    if (el.dataset.color === name) match = el;
  });
  if (!match) return;
  for (var i = 0; i < 3; i++) {
    var url = match.dataset['img' + i];
    var img = document.querySelector('[data-ww-gallery-slot="' + i + '"]');
    if (img && img.tagName === 'IMG' && url) img.src = url;
  }
}

function ww_applyAccent(accent, name, headerEl) {
  document.documentElement.style.setProperty('--ww-accent', accent);
  if (headerEl) {
    headerEl.style.setProperty('--color-background-top-row', 'rgba(' + ww_hexToRgb(accent) + ', 1)');
  }
  // Keep the iOS/Safari UI color in sync with every accent change, whatever
  // triggered it (hero swatch, variant picker, or restored from storage).
  ww_setMetaThemeColor(accent);
  ww_applyGallery(name);
}

// Reapply the saved accent's theme-color when a page is restored from the
// bfcache (e.g. iOS Safari back/forward navigation). Registered at the top
// level (not inside DOMContentLoaded) so it's active even if the restore
// happens before that event would otherwise fire.
window.addEventListener('pageshow', function (event) {
  if (!event.persisted) return;
  try {
    var savedAccent = localStorage.getItem('ww_accent');
    if (savedAccent) ww_setMetaThemeColor(savedAccent);
  } catch (e) {}
});

document.addEventListener('DOMContentLoaded', function () {
  var headerEl = document.getElementById('header-component');
  var productBgEls = document.querySelectorAll('.color-custom-main');

  function ww_applyProductBg(accent) {
    productBgEls.forEach(function (el) {
      el.style.setProperty('--color-background', accent);
      el.style.setProperty('--color-background-rgb', ww_hexToRgb(accent));
    });
  }

  // Restore last-picked color on every page (incl. cart), if one was saved
  try {
    var savedAccent = localStorage.getItem('ww_accent');
    var savedName = localStorage.getItem('ww_name');
    if (savedAccent) {
      ww_applyAccent(savedAccent, savedName, headerEl);
      var savedLabel = document.querySelector('[data-ww-color-label]');
      if (savedLabel && savedName) savedLabel.textContent = savedName;
    }
  } catch (e) {}

  // Product page: sync accent color with the selected color variant
  function ww_applyVariantAccent(rawValue) {
    var key = (rawValue || '').trim().toLowerCase();
    var match = WW_VARIANT_COLOR_MAP[key];
    if (!match) return;
    ww_applyAccent(match.accent, match.name, headerEl);
    ww_applyProductBg(match.accent);
    try {
      localStorage.setItem('ww_accent', match.accent);
      localStorage.setItem('ww_name', match.name);
    } catch (e) {}
  }

  // Initial sync on page load, from whichever option is pre-checked
  document.querySelectorAll('variant-picker').forEach(function (picker) {
    var checkedInput = picker.querySelector('input[type="radio"]:checked');
    if (checkedInput) ww_applyVariantAccent(checkedInput.value);
  });

  // Delegated, resilient to Horizon's own DOM morphing after a variant change
  document.addEventListener('click', function (e) {
    var picker = e.target.closest && e.target.closest('variant-picker');
    if (!picker) return;
    setTimeout(function () {
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (checked) ww_applyVariantAccent(checked.value);
    }, 0);
  });
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('input[type="radio"]')) return;
    var picker = e.target.closest('variant-picker');
    if (!picker) return;
    ww_applyVariantAccent(e.target.value);
  });

  // Variant color swap (hero swatches drive --ww-accent globally + hero image + header)
  var dots = document.querySelectorAll('.ww-dot');
  var label = document.querySelector('[data-ww-color-label]');
  var heroImg = document.querySelector('[data-ww-hero-img]');
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      dots.forEach(function (d) { d.classList.remove('active'); });
      dot.classList.add('active');
      ww_applyAccent(dot.dataset.accent, dot.dataset.name, headerEl);
      if (label) label.textContent = dot.dataset.name;
      if (heroImg && dot.dataset.img) {
        heroImg.style.opacity = '0';
        setTimeout(function () {
          heroImg.src = dot.dataset.img;
          heroImg.style.opacity = '1';
        }, 180);
      }
      try {
        localStorage.setItem('ww_accent', dot.dataset.accent);
        localStorage.setItem('ww_name', dot.dataset.name);
      } catch (e) {}
    });
  });

  // FAQ accordion
  document.querySelectorAll('.ww-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ww-faq-item');
      var wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.ww-faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });
});
